interface IOption {
  skipUrl?: string;
}
/**
 * udata单点登录跳转（所有应用拷贝即可）
 * @param {*} option
 */
export function udataLogin(option?: IOption) {
  let loginUrl =
    window.location.origin +
    (window.isMainVisit ? '' : '/smart') +
    '/user?token={tokenValue}&skipUrl=' +
    encodeURIComponent(option && option.skipUrl ? option.skipUrl : window.location.href);
  window.location.href = '/promeApi/login/enter?loginUrl=' + encodeURIComponent(loginUrl);
}
